/**
 * Responsibility: Implement proxy auth behavior for the ai layer.
 * Scope: Owns ai-layer concerns only; cross-layer orchestration is excluded.
 */
import { authStore } from '../ui/stores/auth-store'

export async function getProxyAuthorizationHeader(): Promise<string | null> {
  const user = authStore.user
  if (!user) return null
  try {
    const token = await user.getIdToken()
    return token ? `Bearer ${token}` : null
  } catch {
    return null
  }
}
